import React, { FC } from 'react';
import ArticleCard from './ArticleCard';
import { Article } from '../../pages/learn/articles/[slug]';
import styles from './ArticlePreviews.module.css';
import ArticlesPageButton from './ArticlesPageButton';

interface Props {
  articles: Array<Article>;
}

const ArticlePreviewsLarge: FC<Props> = ({ articles }) => {
  return (
    <>
      <div className='mb-40 grid grid-cols-12 gap-x-8'>
        <div className={`col-start-1 col-span-8 ${styles['large-card-wrapper']}`}>
          <ArticleCard article={articles[0]} />
        </div>
        <div className={`flex flex-col col-start-9 col-span-4 ${styles['large-card-wrapper']}`}>
          {articles.slice(1).map((article, index) => {
            return (
              <React.Fragment key={article.slug}>
                {index === 0 ? (
                  <div className={`mb-8 ${styles['small-card-wrapper']}`}>
                    <ArticleCard article={article} />
                  </div>
                ) : null}
                {index === 1 ? (
                  <>
                    <div className={`mb-8 ${styles['small-card-wrapper']}`}>
                      <ArticleCard article={article} />
                    </div>
                    <ArticlesPageButton />
                  </>
                ) : null}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ArticlePreviewsLarge;
